import { Component, OnInit } from '@angular/core';
import {FormsModule} from '@angular/forms';
import { Router } from '@angular/router';

import { HttpClient, HttpParams } from '@angular/common/http';
import { Location } from '@angular/common';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
  selector: 'app-display-form',
  templateUrl: './display-form.component.html',
  styleUrls: ['./display-form.component.css']
})
export class DisplayFormComponent implements OnInit {
  public downloadArray: Array<any> = [{"bbb":"vvv","kkk":"ddd","lll":"sasd"},{"bbb":"vvv","kkk":"ddd","lll":"sasd"}];
  public displayBoxArr: any = [[]]; 
  //public lines: Array<any> = [];
  public lines: Array<any> = [];
  public rmPercentage:string="";
  public tokenID:string="";
 
  constructor(private http: HttpClient,private router: Router,private dataservice:LayoutService,private _location: Location)
{
  
  let login=sessionStorage.getItem("LoginSession");
  if(login!=null)
  {
      if(login=="true")
      {
        //this.router.navigateByUrl('/display');
      }
      else
      {
        this.router.navigateByUrl('/login');
      }
       
  }
  else
  {
    this.router.navigateByUrl('/login');
  } 
}

ngOnInit() {

//   let displayOutput = null;
//   let re = /\//gi;
//    let username = "AroshaM";//sessionStorage.getItem("UserName");
//    let mode = sessionStorage.getItem("Mode");
//    let plants = sessionStorage.getItem("Plants");
//    let factory = sessionStorage.getItem("Factory");
//    let valueStream = sessionStorage.getItem("ValueStream");
//    let startDate = sessionStorage.getItem("StartDate").replace(re, "-");
//    let endDate = sessionStorage.getItem("EndDate").replace(re, "-");
//    debugger;
//   this.dataservice.GetLayoutData(username,mode,plants,factory,valueStream,startDate,endDate)
 
//   .subscribe(data =>{
//     console.log("GET is successful ", data);
//     this.displayBoxArr=data["m_Item1"];
//     this.lines=data["m_Item4"];
//     this.rmPercentage=data["m_Item2"];
//     this.tokenID=data["m_Item3"];
//   }, error => {
//     console.log("Error", error);
// });
  //displayOutput = sessionStorage.getItem("DisplayBoardOutput");
}



getStyle(item:any) {
  if (item == "R") {
      return "Red";
  }         
  else if (item == "Y") {
      return "Yellow";
  }
  else if (item == "G") {
      return "#32BA38";
  }
  else if (item == "W") {
      return "Red";
  }
  else if (item == "RB") {
      return "Pink";
  }
  else if (item == "RG") {
    return "Purple";
}
}

Back()
{
  this._location.back();
}

ExportToExcel() {
  var csvData = this.ConvertToCSV(this.downloadArray);
  var a = document.createElement("a");
  //a.style.backgroundColor="Blue"
  a.setAttribute('style', 'display:none;');
  document.body.appendChild(a);
  var blob = new Blob([csvData], { type: 'text/csv' });
  var url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = 'download.csv';/* your file name*/
  a.click();
  return 'success';
 

}

ConvertToCSV(objArray: any) {
  var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
  var str = '';
  var row = "";

  for (var index in objArray[0]) {
      //Now convert each value to string and comma-separated
      row += index + ',';
  }
  row = row.slice(0, -1);
  //append Label row with line break
  str += row + '\r\n';

  for (var i = 0; i < array.length; i++) {
      var line = '';
      for (var index in array[i]) {
          if (line != '') line += ','

          line += array[i][index];
      }
      str += line + '\r\n';
  }
  return str;
}

}
